export default "__VITE_ASSET__9k5NsmNc__"